var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer", staticStyle: { "font-size": "14px" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            color: "#ffffff",
            background: "#303030"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "contain-box footer-content",
              staticStyle: { margin: "0" }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticStyle: { flex: "1", display: "flex" } }, [
                  _c("div", {}, [
                    _c("div", { staticClass: "title-content" }, [
                      _vm._v("买家指南")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "foot-item",
                        on: {
                          click: function($event) {
                            return _vm.toHelpPage("4-1")
                          }
                        }
                      },
                      [_vm._v("售后流程")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "foot-item",
                        on: {
                          click: function($event) {
                            return _vm.toHelpPage("3-1")
                          }
                        }
                      },
                      [_vm._v("支付方式")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "foot-item",
                        on: {
                          click: function($event) {
                            return _vm.toHelpPage("2-1")
                          }
                        }
                      },
                      [_vm._v("配送方式")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "foot-item",
                        on: {
                          click: function($event) {
                            return _vm.toHelpPage("1-1")
                          }
                        }
                      },
                      [_vm._v("购物流程")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-left": "100px" } }, [
                    _c("div", { staticClass: "title-content" }, [
                      _vm._v("平台规则")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "foot-item",
                        on: {
                          click: function($event) {
                            return _vm.toHelpPage("5-1")
                          }
                        }
                      },
                      [_vm._v("隐私协议")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-left": "100px" } }, [
                    _c("div", { staticClass: "title-content" }, [
                      _vm._v("关于我们")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "foot-item",
                        on: {
                          click: function($event) {
                            return _vm.toHelpabout(1)
                          }
                        }
                      },
                      [_vm._v("关于我们")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "foot-item",
                        on: {
                          click: function($event) {
                            return _vm.toHelpabout()
                          }
                        }
                      },
                      [_vm._v("联系我们")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "foot-item",
                        on: {
                          click: function($event) {
                            return _vm.toHelpabout()
                          }
                        }
                      },
                      [_vm._v("营业执照")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0)
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-service" }, [
      _c("div", { staticStyle: { width: "250px" } }, [
        _c(
          "div",
          {
            staticStyle: {
              "font-family": "PingFang SC",
              "font-weight": "bold",
              "font-size": "20px",
              color: "#FFFFFF"
            }
          },
          [_vm._v("服务热线")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "font-weight": "bold",
              "font-size": "18px",
              "line-height": "50px",
              color: "#FFFFFF"
            }
          },
          [_vm._v("4006004516")]
        ),
        _vm._v(" "),
        _c("div", { staticStyle: { color: "gray", "font-size": "12px" } }, [
          _vm._v("工作时间：9:00 -18:00")
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-bottom": "10px" } })
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticStyle: {
              height: "30px",
              "font-family": "PingFang SC",
              "font-weight": "bold",
              "font-size": "20px",
              color: "#FFFFFF",
              "text-align": "center"
            }
          },
          [_vm._v("关注小程序")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer-app" }, [
          _c("img", { attrs: { src: require("../../../public/img/app.jpg") } })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-757c3028", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-757c3028","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/foot/index.vue
// module id = null
// module chunks = 